export interface TimeRange {
  id?: number;
  weekday: number;
  start_time: string;
  end_time: string;
}

export interface TimeException {
  id?: number;
  exception_day: number;
  exception_month: number;
  exception_year?: number | null;
  exception_date?: string;
  description: string;
  is_available: boolean;
  created_at?: string;
}

export interface TimeCondition {
  id: number;
  user_id: number;
  description: string;
  active: boolean;
  time_ranges: TimeRange[];
  created_at: string;
  updated_at?: string;
}

export const WEEKDAYS = [
  { value: 0, label: 'Domingo' },
  { value: 1, label: 'Segunda-feira' },
  { value: 2, label: 'Terça-feira' },
  { value: 3, label: 'Quarta-feira' },
  { value: 4, label: 'Quinta-feira' },
  { value: 5, label: 'Sexta-feira' },
  { value: 6, label: 'Sábado' },
];

export const MONTHS = [
  { value: 1, label: 'Janeiro' },
  { value: 2, label: 'Fevereiro' },
  { value: 3, label: 'Março' },
  { value: 4, label: 'Abril' },
  { value: 5, label: 'Maio' },
  { value: 6, label: 'Junho' },
  { value: 7, label: 'Julho' },
  { value: 8, label: 'Agosto' },
  { value: 9, label: 'Setembro' },
  { value: 10, label: 'Outubro' },
  { value: 11, label: 'Novembro' },
  { value: 12, label: 'Dezembro' },
];
